import { ROLES } from '@tempus/trials-types';

import { FEATURE_FLAG } from '~/constants/feature-flags';

/** Matches `NEXT_PLATFORM_APQ_USER` in trials `roles.export.ts`*/
export const NEXT_PLATFORM_APQ_USER_ROLE = 'NEXT_PLATFORM_APQ_USER';

export const hasBuilderFeatureFlags = (features: string[]): boolean => features.includes(FEATURE_FLAG.BUILDER_UI);

export const canEditCohortBuilderJdm = (effectiveRoles: string[]): boolean =>
  effectiveRoles.includes(ROLES.NEXT_PRESCREENING_USER) || effectiveRoles.includes(ROLES.T_ADMIN);

export const canEditCohortBuilderApq = (effectiveRoles: string[]): boolean =>
  effectiveRoles.includes(NEXT_PLATFORM_APQ_USER_ROLE) ||
  effectiveRoles.includes(ROLES.NEXT_PRESCREENING_USER) ||
  effectiveRoles.includes(ROLES.T_ADMIN);

/** Cohort Builder nav and routes: flags plus prescreening or APQ role. */
export const canAccessCohortBuilder = (features: string[], effectiveRoles: string[]): boolean =>
  hasBuilderFeatureFlags(features) &&
  (canEditCohortBuilderJdm(effectiveRoles) || effectiveRoles.includes(NEXT_PLATFORM_APQ_USER_ROLE));

export const isApqOnlyCohortBuilderUser = (effectiveRoles: string[]): boolean =>
  canEditCohortBuilderApq(effectiveRoles) && !canEditCohortBuilderJdm(effectiveRoles);
